(function () {
  'use strict';
  function init(scope) {
    scope.querySelectorAll('[data-frn-open]').forEach(function (button) { button.hidden = false; });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var opener = event.target.closest('[data-frn-open]');
    if (opener) {
      var dialog = document.getElementById(opener.dataset.frnOpen);
      if (!dialog) return;
      var video = dialog.querySelector('video');
      if (!video.src) video.src = video.dataset.src;
      window.fizzyPopupMotion.open(dialog);
      video.play().catch(function () { /* Native controls remain available. */ });
    }
    var closer = event.target.closest('[data-frn-close]');
    if (closer) window.fizzyPopupMotion.close(closer.closest('dialog'));
    if (event.target.matches('.frn-dialog')) {
      var rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) window.fizzyPopupMotion.close(event.target);
    }
  });
  document.addEventListener('close', function (event) {
    if (!event.target.matches || !event.target.matches('.frn-dialog')) return;
    var video = event.target.querySelector('video');
    video.pause();
    video.removeAttribute('src');
    video.load();
  }, true);
})();
